export default __webpack_public_path__ + "static/illo-hire-56a49c2ab783343740682cbeb0b4f623.svg";